/**
 * The option sets shared by the block style controls, so the format toolbar's
 * knobs and the `align` prop generated from `fpPropSchema` offer exactly the
 * same values.
 */

/** The text alignments offered for a block. */
export const TEXT_ALIGN_OPTIONS = ["left", "center", "right", "justify"];

/** The alignments offered for an fp-image block (justify means nothing). */
export const IMAGE_ALIGN_OPTIONS = ["left", "center", "right"];
